import { render, staticRenderFns } from "./PublishingFundsPgHeader.vue?vue&type=template&id=5ee17787&scoped=true&"
import script from "./PublishingFundsPgHeader.vue?vue&type=script&lang=js&"
export * from "./PublishingFundsPgHeader.vue?vue&type=script&lang=js&"
import style0 from "./PublishingFundsPgHeader.vue?vue&type=style&index=0&id=5ee17787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee17787",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
